export default "__VITE_ASSET__f494c472__"